/**
 * Build initials from a display name (e.g. "Jane Doe" -> "JD", "Madonna" -> "MA").
 */
export function deriveInitialsFromName(name) {
	const trimmed = (name || "").trim();
	if (!trimmed) return "";
	const parts = trimmed.split(/\s+/).filter(Boolean);
	const letter = (ch) => {
		if (!ch) return "";
		const u = ch.toUpperCase();
		return /[A-Z0-9]/.test(u) ? u : "";
	};
	if (parts.length === 1) {
		const w = parts[0].replace(/[^A-Za-z0-9]/g, "");
		if (!w) {
			const c0 = letter(parts[0][0]);
			const c1 = letter(parts[0][1] || "");
			return (c0 + c1).toUpperCase();
		}
		if (w.length === 1) return w.toUpperCase();
		return w.slice(0, 2).toUpperCase();
	}
	const first = letter(parts[0][0]);
	const last = letter(parts[parts.length - 1][0]);
	return (first + last).toUpperCase();
}

/**
 * Best-effort signer display name from client storage (internal users).
 */
export function getSignerDisplayNameFromStorage() {
	try {
		const raw = localStorage.getItem("docplace");
		if (!raw) return "";
		const docplace = JSON.parse(raw);
		return (
			docplace.fullName ||
			docplace.name ||
			docplace.displayName ||
			docplace.userName ||
			(docplace.email ? String(docplace.email).split("@")[0] : "") ||
			""
		);
	} catch {
		return "";
	}
}
